import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import Footer from "examples/Footer";
import DataTable from "examples/Tables/DataTable";
import { useEffect, useState } from "react";
import MDButton from "components/MDButton";
import CreateAccountForm from "./create_account_form";
import UpdateAccountForm from "./update_account_form";
import getAccountsTableData from "./data/accountsTableData";
import { getAccountsCall } from "api/api";
import MDInput from "components/MDInput";
import useStyles from "./styles";
import { CheckPermissionRender } from "../../helpers/checkPermission";
import permissions from "../../config/permissions";
import MobileNavbar from "examples/Navbars/MobileNavbar";
import { Icon, Pagination } from "@mui/material";
import { useIsMobile } from "hooks/useIsMobile";
import TransferAccountForm from "./transfer_account_form";
import TransfersPopup from "./transfers_popup";
import LateReadingCreatePopup from "./late_reading_create_popup";
import LateReadingsPopup from "./late_readings_popup";

const limit = 10;

function Accounts() {
  const classes = useStyles();
  const [state, setState] = useState({
    columns: [],
    rows: [],
    createModalOpen: false,
    lateReadingModelOpen: false,
    searchText: "",
    page: 1,
    totalPages: 1,
  });

  const isMobile = useIsMobile();
  const [accountToEdit, setAccountToEdit] = useState(null);
  const [accountToTransfer, setAccountToTransfer] = useState(null);

  const getAllAccounts = async (search = "", page = 1) => {
    const response = await getAccountsCall(search, page, limit);
    if (response) {
      const { data, page, totalPages } = response;
      const { columns, rows } = getAccountsTableData(data, onEdit, onTransfer);
      setState({
        ...state,
        columns: columns,
        rows: rows,
        createModalOpen: false,
        page,
        totalPages,
      });
      setAccountToEdit(null);
    }
  };
  useEffect(() => {
    getAllAccounts("", 1);
  }, []);

  const createModel = (open) => {
    setState({ ...state, createModalOpen: open });
  };

  const onEdit = (account) => {
    setAccountToEdit(account);
  };

  const onTransfer = (account) => {
    setAccountToTransfer(account);
  };

  const setLateReadingModelOpen = (open) => {
    setState({ ...state, lateReadingModelOpen: open });
  };

  return (
    <DashboardLayout>
      <MobileNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={2}
                px={2}
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
                display="flex"
                justifyContent="space-between"
                alignItems={isMobile ? "left" : "center"}
                flexDirection={isMobile ? "column" : "row"}
              >
                <MDTypography variant="h6" color="white">
                  Accounts
                </MDTypography>
                <div
                  style={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}
                >
                  <MDBox width="12rem" ml="auto" mr={2}>
                    <MDInput
                      placeholder="Search..."
                      value={state.searchText}
                      size="small"
                      fullWidth
                      style={{
                        backgroundColor: "#ffffff66",
                        borderRadius: "5px",
                      }}
                      onChange={({ currentTarget }) => {
                        setState({ ...state, searchText: currentTarget.value });
                      }}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          getAllAccounts(state.searchText, 1);
                        }
                      }}
                      InputProps={{
                        classes: { input: classes.input },
                        endAdornment: (
                          <Icon
                            onClick={() => {
                              getAllAccounts(state.searchText, 1);
                            }}
                            style={{
                              cursor: "pointer",
                              background: "white",
                              height: "28px",
                              width: "28px",
                              borderRadius: "100%",
                              padding: "3px",
                            }}
                            fontSize="medium"
                          >
                            search
                          </Icon>
                        ),
                      }}
                    />
                  </MDBox>

                  <CheckPermissionRender permissions={permissions().account().create().list()}>
                    <MDButton
                      onClick={() => {
                        createModel(true);
                      }}
                      variant="gradient"
                      color="dark"
                    >
                      {isMobile ? <Icon>add</Icon> : "add new account"}
                    </MDButton>
                  </CheckPermissionRender>

                  <CheckPermissionRender
                    permissions={permissions().account().orgConfig().update().list()}
                  >
                    <MDBox ml={1}>
                      <MDButton
                        onClick={() => {
                          setLateReadingModelOpen(true);
                        }}
                        variant="gradient"
                        color="dark"
                      >
                        <Icon>watch_later</Icon>
                      </MDButton>
                    </MDBox>
                  </CheckPermissionRender>
                </div>
              </MDBox>
              <MDBox pt={3}>
                <DataTable
                  table={{ columns: state.columns, rows: state.rows }}
                  isSorted={false}
                  entriesPerPage={false}
                  showTotalEntries={false}
                  noEndBorder
                />
                <Pagination
                  style={{
                    justifySelf: "right",
                    margin: "10px 0px",
                  }}
                  page={state.page}
                  count={state.totalPages}
                  variant="text"
                  color="standard"
                  onChange={(e, newPage) => {
                    getAllAccounts(state.searchText, newPage);
                  }}
                />
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      {/* <Footer /> */}
      <CheckPermissionRender permissions={permissions().account().update().list()}>
        <UpdateAccountForm
          account={accountToEdit}
          onClose={() => {
            setAccountToEdit(null);
          }}
          reload={getAllAccounts}
        />
      </CheckPermissionRender>
      <CheckPermissionRender permissions={permissions().account().create().list()}>
        <CreateAccountForm
          open={state.createModalOpen}
          onClose={() => {
            createModel(false);
          }}
          reload={getAllAccounts}
        />
      </CheckPermissionRender>
      <CheckPermissionRender permissions={permissions().account().update().list()}>
        <TransferAccountForm
          account={accountToTransfer}
          onClose={() => {
            setAccountToTransfer(null);
          }}
          reload={getAllAccounts}
        />
      </CheckPermissionRender>
      <CheckPermissionRender permissions={permissions().orgConfig().update().list()}>
        <LateReadingCreatePopup
          open={state.lateReadingModelOpen}
          setOpen={setLateReadingModelOpen}
        />
      </CheckPermissionRender>
      <TransfersPopup />
      <LateReadingsPopup reload={getAllAccounts} />
    </DashboardLayout>
  );
}

export default Accounts;
